import React, {useEffect, useState} from 'react'
import {Col, Row, Select, Typography} from "antd";
import {
    CalendarOutlined,
    DollarCircleOutlined,
    FieldTimeOutlined,
    SortAscendingOutlined,
    SortDescendingOutlined,
} from "@ant-design/icons";

const {Title, Text} = Typography
const {Option} = Select

function CollectionSortButton(props) {

    const [defaultValue, setDefaultValue] = useState(props.order ?? 'Sort By')
    useEffect(()=>{
        setDefaultValue(props.order ?? 'Sort By')
    }, [props.order])

    return (
        <Row align='middle' gutter={{xs: 8, sm: 16, md: 24}} style={{minWidth: 320, marginLeft: 'auto', marginRight: 'auto', marginTop: 4}}>
            <Col>
                <Title level={4}>
                    <SortAscendingOutlined/> Sort
                </Title>
            </Col>
            <Col>
                <Select
                    style={{marginBottom: 12}}
                    defaultValue={defaultValue}
                    dropdownMatchSelectWidth={false}
                    listHeight={512}
                    onChange={(value) => {
                        if (props.onChange)
                            props.onChange(value)
                    }}
                >
                    <Option value='title'>
                        <SortAscendingOutlined/> Title (a-z)
                    </Option>
                    <Option value='-title'>
                        <SortDescendingOutlined/> Title (z-a)
                    </Option>
                    <Option value='-created_at'>
                        <FieldTimeOutlined/> Date Added (recent)
                    </Option>
                    <Option value='created_at'>
                        <FieldTimeOutlined/> Date Added (old)
                    </Option>
                    <Option value='-updated_at'>
                        <FieldTimeOutlined/> Last Updated (recent)
                    </Option>
                    <Option value='updated_at'>
                        <FieldTimeOutlined/> Last Updated (old)
                    </Option>
                </Select>
            </Col>
        </Row>
    )
}

export default CollectionSortButton